module.exports = __webpack_public_path__ + "img/swl-assessment.353a1870.png";